module.exports = __webpack_public_path__ + "img/patent.1b8f945e.svg";